import { type ReactNode } from 'react';
import { createPortal } from 'react-dom';

import styles from '@admin/molecules/Modal/Modal.module.scss';
import { BaseModalType } from '@admin/organisms/BaseModal/BaseModalProvider';
import { useModalContext } from '@admin/organisms/BaseModal/useModalContext';
import { type ArticleBlockType } from '@common/clients/api';

export type ContextKeyBaseModalType = BaseModalType | ArticleBlockType | string;

interface Props {
    children: ReactNode | ReactNode[];
    contextKey?: BaseModalType | ArticleBlockType | string;
    className?: string;
    render?: true;
}

export enum ModalActions {
    create = 'create',
    update = 'update',
}

export const BaseModal = ({
    children,
    contextKey = BaseModalType.Default,
    className = '',
    render,
}: Props) => {
    const { state } = useModalContext(contextKey);

    const show = state?.show;
    const classNames = ['Modal', styles.Modal, 'shown', styles.shown, className];
    if (!show && !render) return null;

    const handleFormSubmit = (event: React.FormEvent<HTMLElement>) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const modalContent = (
        <aside className={classNames.join(' ')} onSubmit={handleFormSubmit}>
            <section>{children}</section>
        </aside>
    );

    // Use portal to render modal at document body level to avoid nested forms
    if (typeof document !== 'undefined') {
        return createPortal(modalContent, document.body);
    }

    return modalContent;
};
